import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { useSelector } from "react-redux";
import { handleDetailResponse, seo } from "utils/utils";
import VideoModel from "../../component/common/videoModel";
import ImageRender from "../../component/common/ImageRender";
import Breadcrumb from "component/common/breadcrumb";
import PdfViewer from "component/common/pdfViewer";

const ViewPropertyNext = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { property_id = "", doc_type = "image" } = params || {};
  const [viewDetails, setViewDetails] = useState([]);
  const [videoDetails, setVideoDetails] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isPdfView, setIsPdfView] = useState(false);
  const [urlData, setUrlData] = useState(null);
  const getPropertyDetailSelector =
    useSelector((state) => state.propertyData) || [];

  useEffect(() => {
    const { response = null } = getPropertyDetailSelector;
    if (response) {
      setViewDetails(
        handleDetailResponse(response?.data)?.property_document.filter(
          (item) => item.document_type === doc_type
        ) || [],
        setUrlData(handleDetailResponse(response?.data)?.base_url)
      );
    }
  }, [getPropertyDetailSelector]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    seo({
      title: "Property Details Image",
      metaDescription: "View property details",
      canonicalLink: window.location.href,
    });
  }, []);
  return isPdfView ? (
    <PdfViewer
      pdfUrl={pdfUrl}
      backButton={() => {
        setIsPdfView(false);
        setPdfUrl(null);
      }}
    />
  ) : (
    <div className="page-body">
      <VideoModel data={videoDetails} />
      <Breadcrumb
        title={strings.gallery}
        titleactive={strings.gallery}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card row">
              <div className="card-header">
                <div className="col-sm-12">
                  <h5>{strings.gallery}</h5>
                </div>
              </div>
              <div className="my-gallery card-body row" itemScope="">
                {viewDetails &&
                  viewDetails.map((item, i) =>
                    doc_type === "image" ? (
                      <ImageRender
                        key={i}
                        isGallery={true}
                        baseUrl={urlData}
                        imageUrl={item.document}
                        thumbnailUrl={item.document}
                      />
                    ) : doc_type === "video" ? (
                      <div className="col-xl-3">
                        <img
                          src={urlData + item.video_thumbnail}
                          className="img-thumbnail"
                          style={{
                            position: "relative",
                          }}
                        />
                        <i
                          className="fa fa-play theme-fa-icon"
                          style={{
                            position: "absolute",
                            right: "107px",
                            top: "52px",
                            fontSize: "xx-large",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                          data-toggle="modal"
                          data-original-title="test"
                          data-target="#exampleModal"
                          onClick={() => {
                            item.base_url = urlData;
                            setVideoDetails(item);
                          }}
                        ></i>
                      </div>
                    ) : doc_type === "document" ? (
                      <div className="col-xl-1">
                        <a
                          onClick={() => {
                            setPdfUrl(urlData + item.document);
                            setIsPdfView(true);
                          }}
                          // href={urlData + item.document} target={"_blank"}
                        >
                          <img
                            src="/assets/images/documentIcon.png"
                            className="img-fluid view_pro"
                          />
                        </a>{" "}
                      </div>
                    ) : (
                      <img
                        className="img-thumbnail"
                        src={"/assets/images/big-lightgallry/013.jpg"}
                      />
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewPropertyNext;
